import React from 'react';
import Layout from './Sections';
import Contact from './Sections/contact';
import { homeObjOne, homeObjTwo } from './Sections/data';
import Projects from './Sections/projects';
import Services from './Sections/services';
import Footer from './Sections/footer';



export default function Main() {


    // https://www.pixeltrue.com/free-packs/minimalistic-illustrations (animated svg pack source)

    return(
        <div>
            <Layout {...homeObjOne}/>
            <Services  />
            <Projects  />
            <Layout {...homeObjTwo}/>
            <Contact  />
            <Footer />
        </div>
    )
}

